import { DesignLayoutType, EventPageType } from '@graphql/generated-base';
import type { MobileTopBarNavPage } from './MobileTopBarNav.types';

const EXCLUDED_SLUGS = new Set(['rsvp', 'guests']);

export const selectMobileTopBarNavPages = (pages: ReadonlyArray<MobileTopBarNavPage>, layout: DesignLayoutType): ReadonlyArray<MobileTopBarNavPage> => {
  return pages.filter(p => {
    if (EXCLUDED_SLUGS.has(p.pageSlug)) return false;
    if (layout === DesignLayoutType.brannan && p.type === EventPageType.tidbits) return false;
    return true;
  });
};
